<template>
  <v-container v-resize="compileHeader">
    <v-layout row wrap v-if="!loaded">
      <v-flex offset-xs5 offset-sm6 pt-5>
        <v-progress-circular :size="70" :width="7" color="light-blue darken-4" indeterminate></v-progress-circular>
      </v-flex>
    </v-layout>
    <v-card v-if="loaded">
      <v-card-title class="headline">
        Corsi
        <v-layout row>
          <v-flex xs3 v-if="isUserAdmin">
            <CourseDialog />
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout row wrap mb-3>
        <v-flex xs4 md2 ml-3>
          <v-select v-model="filter" :items="parameters" label="Filtro Corsi"></v-select>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs12 md8 lg5 mx-3>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Cerca"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="filteredCourses"
        :search="search"
        :loading="loading"
        :rows-per-page-items="[10,25,40]"
        rows-per-page-text="Righe per pagina"
      >
        <template v-slot:items="props">
          <tr
            class="selectable"
            :class="props.item.color"
            :id="props.item.id"
            @click="selectCourse(props.item.id, props.item.status, props.item.nome)"
          >
            <td>{{ props.item.nome }}</td>
            <td>
              <v-chip :class="props.item.colorChip"></v-chip>
            </td>
            <td class="courseDate">{{ props.item.data_inizio | dateFilter }}</td>
            <td class="hidden-sm-and-down courseDate">{{ props.item.data_fine | dateFilter}}</td>
            <td class="hidden-sm-and-down">{{ props.item.posti }}</td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert
            :value="true"
            color="error"
            icon="warning"
          >La tua ricerca per "{{ search }}" non ha dato risultati.</v-alert>
        </template>
        <template v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">Nessun valore da visualizzare</v-alert>
        </template>
        <template
          v-slot:pageText="props"
        >{{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
      </v-data-table>
    </v-card>
    <v-flex mt-5 v-if="loaded">
      <v-card max-width="300">
        <v-list>
          <v-list-tile v-for="item in items" :key="item.text">
            <v-list-tile-action>
              <v-chip :color="item.color"></v-chip>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title v-text="item.text"></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>
  </v-container>
</template>

<script>
import CourseDialog from "../components/NewCourseDialog";
import { db } from "../main";
import { bus } from "../main";
import { CoursesMixin } from "../mixins/CoursesMixin";
export default {
  mixins: [CoursesMixin],
  components: { CourseDialog },
  data: () => ({
    search: "",
    headers: [],
    courses: [],
    filteredCourses: [],
    parameters: ["Tutti", "Terminati", "In corso", "Da iniziare"],
    items: [
      { text: "In Corso", color: "yellow lighten-1" },
      { text: "Da Iniziare", color: "green lighten-1" },
      { text: "Terminato", color: "red lighten-1" }
    ],
    filter: "Tutti",
    screenWidth: 0,
    loaded: false,
    loading: false
  }),

  computed: {
    //controlla se l'utente è admin
    isUserAdmin() {
      return this.$store.getters.getRole === "Admin";
    }
  },
  watch: {
    //filtro per la tabella dei corsi
    filter(filter) {
      const courses = this.courses;
      this.filteredCourses = [];
      courses.forEach(course => {
        if (filter === "Tutti") {
          if (course.status === "In corso" || course.status === "Da iniziare") {
            this.filteredCourses.push(course);
          }
        } else if (filter === "Terminati") {
          if (course.status === "Terminato") {
            this.filteredCourses.push(course);
          }
        } else if (filter === "In corso") {
          if (course.status === "In corso") {
            this.filteredCourses.push(course);
          }
        } else if (filter === "Da iniziare") {
          if (course.status === "Da iniziare") {
            this.filteredCourses.push(course);
          }
        }
      });
    }
  },
  methods: {
    //metodo per il popolamento della tabella Corsi con le info dei singoli corsi e lo status di questi
    listener() {
      db.collection("corsi")
        .get()
        .then(querySnapshot => {
          this.courses = [];
          this.filteredCourses = [];
          var color = "";
          var colorChip = "";
          const currentDay = new Date().toISOString().substr(0, 10);
          var registeredCourse = this.$store.getters.getRegisteredCourses;
          var status = "";
          querySnapshot.forEach(doc => {
            if (registeredCourse.includes(doc.id)) {
              color = "greenColor";
            } else {
              color = "";
            }
            if (this.$store.getters.getRole === "Admin") {
              if (
                currentDay < doc.data().data_fine &&
                currentDay >= doc.data().data_inizio
              ) {
                status = "In corso";
                colorChip = "yellow lighten-1";
              } else if (currentDay < doc.data().data_inizio) {
                status = "Da iniziare";
                colorChip = "green lighten-1";
              } else if (currentDay >= doc.data().data_fine) {
                status = "Terminato";
                colorChip = "red lighten-1";
              }

              let postiTot = doc.data().posti_tot;
              let postiOcc = doc.data().posti_occupati;
              const course = {
                nome: doc.data().nome,
                data_inizio: doc.data().data_inizio,
                data_fine: doc.data().data_fine,
                posti: postiOcc + "/" + postiTot,
                id: doc.id,
                color: color,
                colorChip: colorChip,
                status: status
              };
              this.courses.push(course);
              if (
                course.status === "In corso" ||
                course.status === "Da iniziare"
              ) {
                this.filteredCourses.push(course);
              }
            } else if (doc.data().data_fine > currentDay) {
              if (
                currentDay < doc.data().data_fine &&
                currentDay >= doc.data().data_inizio
              ) {
                status = "In corso";
                colorChip = "yellow lighten-1";
              } else if (
                currentDay < doc.data().data_inizio &&
                currentDay < doc.data().data_fine
              ) {
                status = "Da iniziare";
                colorChip = "green lighten-1";
              }
              let postiTot = doc.data().posti_tot;
              let postiOcc = doc.data().posti_occupati;
              const course = {
                nome: doc.data().nome,
                data_inizio: doc.data().data_inizio,
                data_fine: doc.data().data_fine,
                posti: postiOcc + "/" + postiTot,
                id: doc.id,
                color: color,
                colorChip: colorChip,
                status: status
              };
              this.courses.push(course);
              this.filteredCourses.push(course);
            }
          });
          this.loaded = true;
        })
        .catch(error => {
          bus.$emit(
            "errorOperation",
            "Errore: problema nel caricamento dei corsi(" + error + ")"
          );
        });
    },
    //metodo per il riempimento dell'header della tabella in base alla larghezza dello schermo
    compileHeader() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth <= 960) {
        this.headers = [
          {
            text: "Nome",
            align: "left",
            value: "nome"
          },
          {
            text: "Status",
            value: "status"
          },
          {
            text: "Data Inizio",
            value: "data_inizio"
          }
        ];
      } else {
        this.headers = [
          {
            text: "Nome",
            align: "left",
            value: "nome"
          },
          {
            text: "Status",
            value: "status"
          },
          {
            text: "Data Inizio",
            value: "data_inizio"
          },
          {
            text: "Data Fine",
            value: "data_fine"
          },
          {
            text: "Posti Occupati",
            value: "posti"
          }
        ];
      }
    }
  },
  mounted() {
    this.compileHeader();
  },

  //inizializzazione dei metodi per il riempimento della tabella Corsi
  created() {
    this.compileHeader();
    this.listener();
    bus.$on("modified", data => {
      // this.modified = data;
      if (data === true) {
        this.listener();
      }
    });
  }
};
</script>
